/* note to self - find out what this does and probably rewrite it */
/*****************************************************
* 
*	Jurisdiction selector
* 
*****************************************************/

	ele.jurisdiction = {
		//Initiate Jurisdicton selector
        textFilter: "",
		initSelector: function(){
			var $jurisdictionSelector = $('#jurisdictionSelector');
			var wto;

            //change listener
            $jurisdictionSelector.change(function(){
                $('.e_productsGlobal, .e_products').removeClass('sHidden');
                $('.e_products table').removeClass('sHidden');
                $('.e_noDocsInJurisdiction').addClass('sHidden');

                var originalProducts = document.querySelectorAll(".e_productsGlobal, .e_products");
                for (var i = 0; i < originalProducts.length; i ++) {
                    originalProducts[i].classList.remove('sHidden');
                }
                //Run filter to show/hide products
                ele.jurisdiction.filter($jurisdictionSelector.val());
                //jurisdiction selection saved on session
                if (ele.config.jurisdictions.selectJurisdictionBeforeShowingProducts) {
                    if ($jurisdictionSelector.val() == '-') {
                        for (var i = 0; i < originalProducts.length; i ++) {
                            originalProducts[i].classList.add('sHidden');
                        }
                    } else {
                        if ($jurisdictionSelector.val() !== null) {
                            for (var i = 0; i < originalProducts.length; i ++) {
                                originalProducts[i].classList.remove('sHidden');
                            }
                        }
                    }
                    
                    clearTimeout(wto);
                    wto = setTimeout(function() {
                        if ($jurisdictionSelector.val() != '-' && $jurisdictionSelector.val() !== null) {
                            jQuery.post('..' + ele.config.directory + '/index.cfm?event=storeJurisdictionInSession', {jurisdictionID: $('#jurisdictionSelector').val()})
                        }
                    }, 3000);
                }
            });

            //find the initial value set by server and load onto dropdown
            let initialJurisdiction = ele.config.jurisdictions.initialJID;
            let searchRegEx = new RegExp('search')
            if (initialJurisdiction === null || initialJurisdiction === 0 && ele.config.jurisdictions.selectJurisdictionBeforeShowingProducts || ele.config.jurisdictions.selectJurisdictionBeforeShowingProducts && !ele.config.jurisdictions.jurisdictionSetProperlyAtRegistration) initialJurisdiction =  "-";

            // Don't do this on the search page as the whole thing reloads so this would keep you trapped on your starting region
            if(!searchRegEx.test(ele.config.usersession.event)){
                $jurisdictionSelector.val(initialJurisdiction).change();
            }

			//we've also tacked on a little product text filter too. listener for this
            if(!!document.getElementById("productListFilter")) {
                $("#productListFilter").on("keyup", function (e) {
                    ele.jurisdiction.textFilter = $("#productListFilter").val();
                    $jurisdictionSelector.change();
                });
            }

		},

        checkTableVisibility: function() {
            var anyTableVisible = false;

            // Different DOM structures for essentially the same output has led to lots of repeating ourselves in this function

            // Subscription tables
            $('.e_products table').each(function() {
              var $tbody = $(this).find('tbody');
              var isVisible = $tbody.children().filter(function() {
                return $(this).css('display') !== 'none';
              }).length > 0;
          
              if (isVisible) {
                anyTableVisible = true;
                $(this).removeClass('sHidden');
              } else {
                $(this).addClass('sHidden');
              }
            });

            // Subsite products
            $('.ele-subsiteProducts .e_productCategories').each(function() {
                // Track if any are showing at all
                // Show all
                let id = $(this).attr('id');
                $(`#quick_link_${id}`).removeClass('sHidden'); 
                $(this).removeClass('sHidden');
                $('.category-menu-button').removeClass('sHidden');
                // Use the .children() method to look for direct child elements with the class e_product
                // Then use the .filter() method to get only the visible ones
                // First find the .e_productsGlobal container
                var productsGlobalContainer = $(this).find('.e_productsGlobal');

                // Now, within the e_productsGlobal container, find any visible .e_product elements
                var visibleChildren = productsGlobalContainer.find('.e_product:not(.sHidden)');
                // If none of the children are visible
                if (visibleChildren.length === 0) {
                    // Hide the parent (i.e., the current e_productCategories element)
                    $(this).addClass('sHidden');
                    // If this is the tabbed solution, we hide the related tab if it has empty contents, if it was an active tab then we switch back to the 'all' tab
                    if($(`#tab-control-${id}`).hasClass('active')){
                        $('#all-tab').trigger('click');
                    }
                    $(`#tab-control-${id}`).addClass('sHidden');
                    // Subsite quick links
                    $(`#quick_link_${id}`).addClass('sHidden'); 
                } else {
                    anyTableVisible = true;
                }
            });

            // Related products
            if($('#e_relatedServices').length){
                let relatedServices = $('#e_relatedServices .relatedContainer .e_products').find('.e_product:visible');
                if (relatedServices.length > 0) {
                    anyTableVisible = true;
                }
            }

            if(!anyTableVisible){
                if ($('#jurisdictionSelector').val() != '-') {
                    $('.e_noDocsInJurisdiction').removeClass('sHidden');
                }
            } else {
                $('.e_noDocsInJurisdiction').addClass('sHidden');
            }
        },

		//To filter a product list by jurisdiction
		filter: function(jid){
			if( $('.e_jurItem').length ){

                var allProducts = document.querySelectorAll('.e_jurItem');

                for (var i = 0; i < allProducts.length; i ++) {
                    if(jid != 0){
                        allProducts[i].classList.add('sHidden');
                    } else {
                        allProducts[i].classList.remove('sHidden');
                    }
                }
                
                if(!!document.getElementById("productListFilter")) {

                    var chosenProducts = document.querySelectorAll(".e_jurId_" + jid);

                    for (var i = 0; i < chosenProducts.length; i ++) {
                        if(ele.jurisdiction.textFilter != ""){
                            var textName = chosenProducts[i].firstElementChild["textContent"].toLowerCase();
                            if(textName.indexOf(ele.jurisdiction.textFilter.toLowerCase()) > -1){
                                chosenProducts[i].classList.remove('sHidden');
                            }
                        } else {
                            chosenProducts[i].classList.remove('sHidden');
                        }
                    }

                } else {
                    var chosenProducts = document.querySelectorAll(".e_jurId_" + jid);
                    for (var i = 0; i < chosenProducts.length; i ++) {
                        chosenProducts[i].classList.remove('sHidden');
                    }
                }

			}
			// If there are no docs in this jurisdiction and category, hide the category
            ele.jurisdiction.checkTableVisibility();
		}
	};
	//Call Jurisdiction initiation
	$('document').ready(function(){
		if ($('#jurisdictionSelector').length > 0 && $('#jurisdictionSelector').is(":visible")){
			ele.jurisdiction.initSelector();
		}
	});
